import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import Home from '../views/Home.vue'
import store from '@/store';
import { localization } from "@/localization";

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/unauthorized',
    name: 'Unauthorized',
    component: () => import('@/components/ErrorHandle/unauthorized.vue')
  },
  {
    path: '/:pathMatch(.*)*',
    //component: () => import('@/components/ErrorHandle/notfound.vue')
    component: Home
  },
  {
    path: '/notfound',
    name: 'NotFound',
    component: () => import('@/components/ErrorHandle/notfound.vue')
  },
  {
    path: '/servererror',
    name: 'ServerError',
    component: () => import('@/components/ErrorHandle/ServerError.vue')
  },
  {
    path: '/forbidden',
    name: 'Forbidden',
    component: () => import('@/components/ErrorHandle/Forbidden.vue')
  },
  {
    path: '/badrequest',
    name: 'Badrequest',
    component: () => import('@/components/ErrorHandle/Badrequest.vue')
  },
  {
    path: '/comporPayment',
    name: 'comporPayment',
    component: () => import('@/views/comporPayment/comporPayment.vue')
  },
  {
    path: '/tmDiscount',
    name: 'tmDiscount',
    component: () => import('@/views/tmDiscount/tmDiscount.vue')
  },
  {
    path: '/patronDiscount',
    name: 'patronDiscount',
    component: () => import('@/views/patronDiscount/patronDiscount.vue')
  },
  {
    path: '/component',
    component: () => import('@/views/ComponentDisplay/ComponentHome.vue'),
    children:[
      {
        path: 'dropdown',
        name: 'Dropdown',
        component: () => import('@/views/ComponentDisplay/Dropdown.vue')
      },
      {
        path: 'breadcrumb',
        name: 'Breadcrumb',
        component: () => import('@/views/ComponentDisplay/Breadcrumb.vue')
      },
      {
        path: 'loading',
        name: 'Loading',
        component: () => import('@/views/ComponentDisplay/Loading.vue')
      },
      {
        path: 'tooltips',
        name: 'Tooltips',
        component: () => import('@/views/ComponentDisplay/Tooltips.vue')
      },
      {
        path: 'dialog',
        name: 'Dialog',
        component: () => import('@/views/ComponentDisplay/Dialog.vue')
      },
      {
        path: 'list',
        name: 'List',
        component: () => import('@/views/ComponentDisplay/List.vue')
      },
      {
        path: 'pagination',
        name: 'Pagination',
        component: () => import('@/views/ComponentDisplay/Pagination.vue')
      },
      {
        path: 'tabs',
        name: 'Tabs',
        component: () => import('@/views/ComponentDisplay/Tabs.vue')
      },
      {
        path: 'form',
        name: 'Form',
        component: () => import('@/views/ComponentDisplay/Form.vue')
      },
      {
        path: 'table',
        name: 'Table',
        component: () => import('@/views/ComponentDisplay/Table.vue')
      },
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})


router.beforeEach(async (to, from, next) => {

  //for home page, specify the language from query parameter
  var lang = to.query['culture']?.valueOf().toString();
  //console.log("lang: " + lang);
  localization.SwitchLanguage(lang);
  //console.log("to.path : " + to.path);
  //load local language message before view mounted
  await localization.loadLocaleMessages();

  if (to.matched.some(record => record.meta.auth)) {
    next({
      path: '/',
      query: { redirect: to.fullPath }
    });
  } else {
    next();
  }
});

router.beforeEach((to, from, next) =>{
  const permissionRequired = to.meta.policy
  if (permissionRequired) {
    if (store.getters["CurrentUser/HAS_PERMISSION"](permissionRequired)) {
      next()
    } else {
      console.log("Unauthorised.")
      next({ path: '/'})
    }
  } else {
    next()
  }
})

export default router
